var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2806050136896",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1528",
    "data-name": "Ellipse 1528",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3396ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17651",
    "data-name": "Path 17651",
    d: "M432.562,736.764a8.958,8.958,0,0,1,12.445,0l.411.4a.426.426,0,0,1,0,.6l-1.413,1.374a.21.21,0,0,1-.308,0l-.565-.552a6.251,6.251,0,0,0-8.682,0l-.6.591a.21.21,0,0,1-.308,0l-1.413-1.374a.426.426,0,0,1,0-.6l.45-.437Zm15.361,2.851,1.259,1.233a.426.426,0,0,1,0,.6l-5.677,5.535a.442.442,0,0,1-.616,0l-4.033-3.93a.117.117,0,0,0-.154,0l-4.033,3.93a.442.442,0,0,1-.616,0l-5.677-5.535a.426.426,0,0,1,0-.6l1.259-1.233a.442.442,0,0,1,.616,0l4.033,3.93a.117.117,0,0,0,.154,0l4.033-3.93a.442.442,0,0,1,.616,0l4.033,3.93a.117.117,0,0,0,.154,0l4.033-3.93a.442.442,0,0,1,.616,0Z",
    transform: "translate(-422.776 -724.845)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.9d559c861a99309b035d9f38c561c815.svg";
export { ForwardRef as ReactComponent };